// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as PassagensRouteImport } from './routes/passagens'
import { Route as EncomendasRouteImport } from './routes/encomendas'
import { Route as IndexRouteImport } from './routes/index'

const TermosRoute = TermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const PassagensRoute = PassagensRouteImport.update({
            id: '/passagens',path: '/passagens',getParentRoute: () => rootRouteImport
          })
const EncomendasRoute = EncomendasRouteImport.update({
            id: '/encomendas',path: '/encomendas',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,EncomendasRoute: EncomendasRoute,PassagensRoute: PassagensRoute,PrivacidadeRoute: PrivacidadeRoute,TermosRoute: TermosRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)